import React from "react";
import { Container, Box } from "@mui/material";

interface PageContainerProps {
  children: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  sx?: object;
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  maxWidth = "lg",
  sx = {},
}) => {
  return (
    <Container maxWidth={maxWidth}>
      <Box sx={{ my: 4, ...sx }}>{children}</Box>
    </Container>
  );
};

export default PageContainer;
